import type { UserResource } from "@clerk/types";

export function isProfileComplete(user: UserResource | null | undefined): boolean {
  if (!user) return false;
  const requiredFields = [
    user.firstName,
    user.lastName,
    user.emailAddresses[0]?.emailAddress,
    user.phoneNumbers[0]?.phoneNumber,
    user.publicMetadata?.city,
    user.publicMetadata?.country,
    user.publicMetadata?.company,
  ];

  return requiredFields.every(Boolean);
}

